import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { AddEditMobileAbout } from "./appabout/AddEditMobileAbout";
import { AppCard } from "./appcard/AppCard";
import { AppHeader } from "./appheader/AppHeader";
import { AppCardsMainContent } from "./appcard/AppCardMainContent";

export const MobileApp: React.FC = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const activeTab = query.get("activeTab");

  useEffect(() => {
    if (!query.get("activeTab")) {
      navigate(`${window.location.pathname}?activeTab=appHeader`, { replace: true });
    }
  }, [navigate, query]);

  const items = [
    { label: "App Header", key: "appHeader", children: <AppHeader /> },
    { label: "App Cards", key: "appCardsMainContent", children: <AppCardsMainContent /> },
    { label: "App About", key: "appAbout", children: <AddEditMobileAbout /> },
  ];

  const handleHomepageAction = (activeTab?: string | null) => {
    if (activeTab === "appCardsMainContent") {
      return (
        <Button
          icon={<Icon icon={"lucide:plus"} />}
          onClick={() => navigate("/dedicated/passenger/mobileapp/cards/add")}
        >
          Add App Card
        </Button>
      );
    }

    return null;
  };

  return (
    <ContentWrapper
      title="Mobile App"
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleHomepageAction(activeTab)}
      airportText={`Airport Specific Content`}
    >
      <Tabs
        activeKey={activeTab || "appHeader"}
        items={items}
        onChange={(activeKey) => navigate(`${window.location.pathname}?activeTab=${activeKey}`)}
      />
    </ContentWrapper>
  );
};

export default MobileApp;
